import React, { useState, useEffect } from 'react'
import { useDemo } from '../DemoProvider'
import DemoBanner from './DemoBanner'
import WelcomeModal from './WelcomeModal'

const DemoMode = ({ children }) => {
  const { isDemoMode } = useDemo()
  const [showWelcome, setShowWelcome] = useState(false)

  // Show welcome modal when entering demo mode
  useEffect(() => {
    if (isDemoMode) {
      setShowWelcome(true)
    }
  }, [isDemoMode])

  return (
    <>
      {isDemoMode && (
        <>
          <DemoBanner />
          {showWelcome && <WelcomeModal onClose={() => setShowWelcome(false)} />}
        </>
      )}
      {children}
    </>
  )
}

export default DemoMode
